var $0a209b5c3feb59ed$exports = {};
/**
 * helpGuide.js
 * A module to manage a step-by-step help guide for the GTAViz application
 */ class $0a209b5c3feb59ed$var$HelpGuide {
    constructor(){
        this.helpSteps = [
            // Panels overview
            {
                target: "#cy",
                title: "Graph Canvas",
                content: "Your main workspace. Zoom, pan, click nodes and edges, or drag them to rearrange. Upload a JSON or TSG file to get started.",
                placement: "left"
            },
            {
                target: "#info",
                title: "Details Panel",
                content: "Click any node or edge to see its properties here \u2014 coordinates, weight, gene annotations, and more.",
                placement: "left"
            },
            {
                target: "#walks",
                title: "Walks Panel",
                content: "Lists all discovered paths through your graph. Search, highlight, or batch-filter walks by GTAViz ID.",
                placement: "left"
            },
            // Toolbar — file operations
            {
                target: "#uploadBtn",
                title: "Upload File",
                content: "Load a JSON or TSG file to visualize a transcript segment graph.",
                placement: "bottom"
            },
            {
                target: "#captureGraph",
                title: "Export Image",
                content: "Save the current graph view as a PNG image.",
                placement: "bottom"
            },
            // Toolbar — view controls
            {
                target: "#toggleMaximize",
                title: "Fullscreen",
                content: "Expand the graph canvas to fill the entire screen.",
                placement: "bottom"
            },
            {
                target: "#hiddenLabel",
                title: "Toggle Labels",
                content: "Show or hide node names and edge weights on the graph.",
                placement: "bottom"
            },
            {
                target: "#toggleTooltip",
                title: "Toggle Tooltips",
                content: "Turn hover tooltips on or off for graph elements.",
                placement: "bottom"
            },
            {
                target: "#resetGraph",
                title: "Reset Layout",
                content: "Re-run the layout algorithm to reposition all nodes.",
                placement: "bottom"
            },
            {
                target: "#clearHighlights",
                title: "Clear Highlights",
                content: "Remove all active node and walk highlights.",
                placement: "bottom"
            },
            // Toolbar — layout & graph selection
            {
                target: "#layoutSelect",
                title: "Layout Algorithm",
                content: "Switch between layout algorithms \u2014 dagre, klay, tidytree, and more \u2014 to arrange the graph differently.",
                placement: "bottom"
            },
            {
                target: "#graphSelectorContainer",
                title: "Graph Selector",
                content: "When a TSG file contains multiple graphs, use this dropdown to switch between them.",
                placement: "bottom"
            },
            // Toolbar — filters (consolidated)
            {
                target: ".toolbar-filter-group",
                title: "Graph Filters",
                content: "Control walk discovery: set a minimum edge weight, and minimum/maximum path depth to focus on the most relevant walks.",
                placement: "bottom"
            },
            // Toolbar — tools
            {
                target: "#geneAnnotationBtn",
                title: "Gene Annotations",
                content: "Annotate graph nodes with gene names and exon data from GENCODE.",
                placement: "bottom"
            },
            {
                target: "#openJsonEditor",
                title: "JSON Editor",
                content: "View or edit the raw graph JSON data in a tree, code, or form view.",
                placement: "left"
            },
            {
                target: "#showNodeRanking",
                title: "Node Ranking",
                content: "Rank nodes by degree, centrality, or other graph metrics.",
                placement: "left"
            },
            // Walks panel — search
            {
                target: "#walkSearch",
                title: "Search Walks",
                content: "Type to filter walks by node IDs or GTAViz IDs.",
                placement: "top"
            },
            {
                target: "#uploadAuroraIds",
                title: "Batch Search",
                content: "Upload a .txt file of GTAViz IDs to filter walks in bulk.",
                placement: "top"
            }
        ];
        this.currentStepIndex = 0;
        this.isGuideActive = false;
        this.overlay = null;
        this.tooltip = null;
        // Load guide progress from local storage
        this.loadProgress();
        // Add help button to the navbar - modified to place button in left navbar
        this.addHelpButton();
        // Show welcome message for first-time visitors
        this.showWelcomeIfFirstVisit();
    }
    /**
     * Show welcome message for first-time visitors
     * Now displays in the left bottom corner of the screen
     */ showWelcomeIfFirstVisit() {
        const hasVisitedBefore = localStorage.getItem("auroraHelpGuideWelcomeSeen");
        if (!hasVisitedBefore) {
            // Create a welcome toast instead of a modal
            const toastHtml = `
        <div class="help-guide-welcome-toast">
          <div class="help-guide-welcome-header">
            <i class="bi bi-question-circle text-primary me-2"></i>
            <strong>Welcome to GTAViz!</strong>
            <button class="help-guide-welcome-close">&times;</button>
          </div>
          <div class="help-guide-welcome-body">
            <p>New here? Take a quick interactive tour to learn the interface.</p>
            <p class="mb-2 small text-muted">Use <kbd>&larr;</kbd> <kbd>&rarr;</kbd> to navigate, <kbd>Esc</kbd> to close.</p>
            <button class="btn btn-sm btn-primary w-100" id="startWelcomeHelpBtn">
              <i class="bi bi-rocket-takeoff me-2"></i> Start Tour
            </button>
          </div>
        </div>
      `;
            // Add CSS for the welcome toast
            const style = document.createElement("style");
            style.textContent = `
        .help-guide-welcome-toast {
          position: fixed;
          bottom: 20px;
          left: 20px;
          width: 320px;
          background-color: white;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
          border-radius: 6px;
          z-index: 9999;
          overflow: hidden;
          animation: slideInUp 0.4s ease-out;
        }

        .help-guide-welcome-header {
          display: flex;
          align-items: center;
          padding: 12px 15px;
          background-color: var(--bg-secondary, #f8f9fa);
          border-bottom: 1px solid var(--border-color, #dee2e6);
        }

        .help-guide-welcome-close {
          margin-left: auto;
          background: none;
          border: none;
          font-size: 1.5rem;
          line-height: 1;
          cursor: pointer;
          color: var(--text-secondary, #475569);
        }

        .help-guide-welcome-body {
          padding: 15px;
        }

        @keyframes slideInUp {
          from {
            transform: translateY(100%);
            opacity: 0;
          }
          to {
            transform: translateY(0);
            opacity: 1;
          }
        }
      `;
            document.head.appendChild(style);
            // Append toast to body
            const toastContainer = document.createElement("div");
            toastContainer.innerHTML = toastHtml;
            document.body.appendChild(toastContainer);
            // Add event listeners
            document.querySelector(".help-guide-welcome-close").addEventListener("click", ()=>{
                document.querySelector(".help-guide-welcome-toast").remove();
                localStorage.setItem("auroraHelpGuideWelcomeSeen", "true");
            });
            document.getElementById("startWelcomeHelpBtn").addEventListener("click", ()=>{
                document.querySelector(".help-guide-welcome-toast").remove();
                localStorage.setItem("auroraHelpGuideWelcomeSeen", "true");
                this.startGuide();
            });
            // Auto-hide after 30 seconds if not interacted with
            setTimeout(()=>{
                const toast = document.querySelector(".help-guide-welcome-toast");
                if (toast) {
                    toast.style.animation = "slideInUp 0.4s ease-out reverse";
                    setTimeout(()=>{
                        if (toast.parentNode) {
                            toast.remove();
                            localStorage.setItem("auroraHelpGuideWelcomeSeen", "true");
                        }
                    }, 400);
                }
            }, 30000);
        }
    }
    /**
     * Add a help button to the navbar for users to start the guide
     * Now placing it after the "What's New" link
     */ addHelpButton() {
        // Find the "What's New" nav item
        const whatsNewNavItem = document.getElementById("showReleaseNotesBtn");
        if (whatsNewNavItem) {
            // Create a new nav item for the help guide
            const helpNavItem = document.createElement("li");
            helpNavItem.className = "nav-item";
            // Create the help button with nav-link styling to match other navbar links
            const helpButton = document.createElement("a");
            helpButton.id = "helpGuideButton";
            helpButton.className = "nav-link";
            helpButton.href = "#";
            helpButton.title = "Start Help Guide";
            helpButton.innerHTML = '<i class="bi bi-question-circle"></i> Help';
            helpButton.addEventListener("click", (e)=>{
                e.preventDefault(); // Prevent default link behavior
                this.startGuide();
            });
            // Add the button to the nav item
            helpNavItem.appendChild(helpButton);
            // Find the parent ul of whatsNewNavItem
            const navParent = whatsNewNavItem.closest("ul");
            // Get the list item containing the "What's New" link
            const whatsNewLi = whatsNewNavItem.closest("li");
            // Insert the help nav item after the "What's New" nav item
            if (whatsNewLi && navParent) navParent.insertBefore(helpNavItem, whatsNewLi.nextSibling);
        }
    }
    /**
     * Start or continue the help guide
     */ startGuide() {
        if (this.isGuideActive) return;
        this.isGuideActive = true;
        // Create overlay
        this.createOverlay();
        // Always start from the first step when manually clicking the help button
        // This fixes the issue with tooltips appearing off-screen
        this.showStep(0);
    }
    /**
     * Create a semi-transparent overlay with a tooltip
     */ createOverlay() {
        // Create overlay if it doesn't exist
        if (!this.overlay) {
            this.overlay = document.createElement("div");
            this.overlay.className = "help-guide-overlay";
            document.body.appendChild(this.overlay);
        }
        // Create tooltip if it doesn't exist
        if (!this.tooltip) {
            this.tooltip = document.createElement("div");
            this.tooltip.className = "help-guide-tooltip";
            document.body.appendChild(this.tooltip);
        }
        // Add keyboard event listeners
        this.addKeyboardListeners();
    }
    /**
     * Add keyboard navigation support
     */ addKeyboardListeners() {
        if (this.keyboardHandler) return; // Already added
        this.keyboardHandler = (event)=>{
            if (!this.isGuideActive) return;
            switch(event.key){
                case "ArrowLeft":
                    event.preventDefault();
                    this.previousStep();
                    break;
                case "ArrowRight":
                case "Enter":
                    event.preventDefault();
                    this.nextStep();
                    break;
                case "Escape":
                    event.preventDefault();
                    this.endGuide();
                    break;
            }
        };
        document.addEventListener("keydown", this.keyboardHandler);
    }
    /**
     * Show a specific step in the guide
     * @param {number} index - The index of the step to show
     */ showStep(index, direction = 1) {
        // Ensure index is valid
        if (index < 0 || index >= this.helpSteps.length) {
            this.endGuide();
            return;
        }
        this.currentStepIndex = index;
        // Get target element
        const step = this.helpSteps[index];
        const targetElement = document.querySelector(step.target);
        // Skip missing or hidden elements (e.g., graphSelectorContainer with d-none)
        const shouldSkip = !targetElement || targetElement.offsetParent === null && !targetElement.matches('#cy') && (targetElement.classList.contains('d-none') || getComputedStyle(targetElement).display === 'none');
        if (shouldSkip) {
            const nextIndex = index + direction;
            if (nextIndex >= 0 && nextIndex < this.helpSteps.length) this.showStep(nextIndex, direction);
            else this.endGuide();
            return;
        }
        // Make target element visible through overlay
        targetElement.classList.add("target-highlight");
        // First make sure the element is in view
        this.scrollElementIntoView(targetElement).then(()=>{
            // Position tooltip near target after scrolling
            this.positionTooltip(targetElement, step.placement);
            // Calculate progress percentage
            const progress = (index + 1) / this.helpSteps.length * 100;
            // Update tooltip content with progress bar and keyboard shortcuts
            this.tooltip.innerHTML = `
        <div class="help-guide-progress">
          <div class="help-guide-progress-bar" style="width: ${progress}%"></div>
        </div>
        <h5>${step.title}</h5>
        <p>${step.content}</p>
        <div class="help-guide-buttons">
          <div class="help-guide-nav-group">
            <button id="helpGuidePrev" class="btn btn-sm btn-outline-secondary"${index === 0 ? " disabled" : ""}>
              <i class="bi bi-chevron-left"></i> Previous
            </button>
            <span class="help-guide-step-indicator">${index + 1} of ${this.helpSteps.length}</span>
            <button id="helpGuideNext" class="btn btn-sm btn-primary">
              ${index === this.helpSteps.length - 1 ? 'Finish <i class="bi bi-check-lg"></i>' : 'Next <i class="bi bi-chevron-right"></i>'}
            </button>
          </div>
          <button id="helpGuideClose" class="btn btn-sm btn-outline-danger">
            <i class="bi bi-x-lg"></i> Close
          </button>
        </div>
        <div class="help-guide-shortcuts">
          <span><kbd>\u{2190}</kbd> <kbd>\u{2192}</kbd> Navigate</span>
          <span><kbd>Enter</kbd> Next</span>
          <span><kbd>Esc</kbd> Close</span>
        </div>
      `;
            // Set placement attribute for arrow positioning
            this.tooltip.setAttribute('data-placement', step.placement);
            // Add step transition animation
            this.tooltip.classList.add('step-transition');
            setTimeout(()=>{
                this.tooltip.classList.remove('step-transition');
            }, 300);
            // Add event listeners to navigation buttons
            document.getElementById("helpGuidePrev").addEventListener("click", ()=>{
                this.previousStep();
            });
            document.getElementById("helpGuideNext").addEventListener("click", ()=>{
                this.nextStep();
            });
            // Add event listener to close button
            document.getElementById("helpGuideClose").addEventListener("click", ()=>{
                this.endGuide();
            });
            // Save progress
            this.saveProgress();
        });
    }
    /**
     * Position the tooltip relative to the target element
     * @param {HTMLElement} targetElement - The target element
     * @param {string} placement - The preferred placement (top, bottom, left, right)
     */ positionTooltip(targetElement, placement) {
        // Ensure the target element is visible first
        this.scrollElementIntoView(targetElement);
        // Get fresh measurements after scrolling
        const targetRect = targetElement.getBoundingClientRect();
        // Wait a moment for the scroll to complete before positioning the tooltip
        setTimeout(()=>{
            const tooltipRect = this.tooltip.getBoundingClientRect();
            // Calculate position based on placement
            let top, left;
            const margin = 15; // Increased margin for better visibility
            // First try the preferred placement
            switch(placement){
                case "top":
                    top = targetRect.top - tooltipRect.height - margin;
                    left = targetRect.left + (targetRect.width - tooltipRect.width) / 2;
                    break;
                case "bottom":
                    top = targetRect.bottom + margin;
                    left = targetRect.left + (targetRect.width - tooltipRect.width) / 2;
                    break;
                case "left":
                    top = targetRect.top + (targetRect.height - tooltipRect.height) / 2;
                    left = targetRect.left - tooltipRect.width - margin;
                    break;
                case "right":
                    top = targetRect.top + (targetRect.height - tooltipRect.height) / 2;
                    left = targetRect.right + margin;
                    break;
                default:
                    top = targetRect.bottom + margin;
                    left = targetRect.left + (targetRect.width - tooltipRect.width) / 2;
            }
            // Get viewport dimensions
            const viewportWidth = window.innerWidth;
            const viewportHeight = window.innerHeight;
            // Adjust position if tooltip would be outside viewport
            // Left edge check
            if (left < margin) left = margin;
            // Right edge check
            if (left + tooltipRect.width > viewportWidth - margin) left = viewportWidth - tooltipRect.width - margin;
            // Top edge check
            if (top < margin) {
                // If it would be off the top, try to place it at the bottom instead
                if (placement === "top") top = targetRect.bottom + margin; // Try bottom placement instead
                else top = margin;
            }
            // Bottom edge check
            if (top + tooltipRect.height > viewportHeight - margin) {
                // If it would be off the bottom, try to place it at the top instead
                if (placement === "bottom") {
                    top = targetRect.top - tooltipRect.height - margin; // Try top placement instead
                    // If that would still be off the top of the viewport, place at the top with margin
                    if (top < margin) top = margin;
                } else // Otherwise, position it so the bottom of the tooltip is just within the viewport
                top = viewportHeight - tooltipRect.height - margin;
            }
            // Set tooltip position
            this.tooltip.style.top = `${top}px`;
            this.tooltip.style.left = `${left}px`;
        }, 250); // Small delay to ensure scrolling has completed
    }
    /**
     * Scroll an element into view if it's not already visible
     * @param {HTMLElement} element - The element to scroll into view
     */ scrollElementIntoView(element) {
        const elementRect = element.getBoundingClientRect();
        const viewportHeight = window.innerHeight;
        const isInView = elementRect.top >= 0 && elementRect.left >= 0 && elementRect.bottom <= viewportHeight && elementRect.right <= window.innerWidth;
        if (!isInView) {
            // Scroll element into view with some margin
            element.scrollIntoView({
                behavior: "smooth",
                block: "center",
                inline: "center"
            });
            // Give some time for scroll to complete
            return new Promise((resolve)=>setTimeout(resolve, 200));
        }
        return Promise.resolve();
    }
    /**
     * Move to the next step in the guide
     */ nextStep() {
        // Remove highlight from current target
        const currentStep = this.helpSteps[this.currentStepIndex];
        const currentTarget = document.querySelector(currentStep.target);
        if (currentTarget) currentTarget.classList.remove("target-highlight");
        // Move to next step or end guide if at last step
        if (this.currentStepIndex === this.helpSteps.length - 1) this.endGuide();
        else this.showStep(this.currentStepIndex + 1);
    }
    /**
     * Move to the previous step in the guide
     */ previousStep() {
        // Remove highlight from current target
        const currentStep = this.helpSteps[this.currentStepIndex];
        const currentTarget = document.querySelector(currentStep.target);
        if (currentTarget) currentTarget.classList.remove("target-highlight");
        // Move to previous step if not at first step
        if (this.currentStepIndex > 0) this.showStep(this.currentStepIndex - 1, -1);
    }
    /**
     * End the help guide
     */ endGuide() {
        this.isGuideActive = false;
        // Remove highlight from current target
        const currentStep = this.helpSteps[this.currentStepIndex];
        if (currentStep) {
            const currentTarget = document.querySelector(currentStep.target);
            if (currentTarget) currentTarget.classList.remove("target-highlight");
        }
        // Remove overlay and tooltip
        if (this.overlay) {
            document.body.removeChild(this.overlay);
            this.overlay = null;
        }
        if (this.tooltip) {
            document.body.removeChild(this.tooltip);
            this.tooltip = null;
        }
        // Remove keyboard event listener
        if (this.keyboardHandler) {
            document.removeEventListener("keydown", this.keyboardHandler);
            this.keyboardHandler = null;
        }
        // Reset current step index for next time
        this.saveProgress();
    }
    /**
     * Save the current progress to local storage
     */ saveProgress() {
        localStorage.setItem("auroraHelpGuideProgress", JSON.stringify({
            lastViewedStep: this.currentStepIndex,
            lastViewedDate: new Date().toISOString()
        }));
    }
    /**
     * Load progress from local storage
     */ loadProgress() {
        try {
            const savedProgress = JSON.parse(localStorage.getItem("auroraHelpGuideProgress"));
            if (savedProgress) {
                // Only restore progress if it's from the last 7 days
                const lastViewedDate = new Date(savedProgress.lastViewedDate);
                const now = new Date();
                const daysDiff = (now - lastViewedDate) / 86400000;
                if (daysDiff <= 7) this.currentStepIndex = savedProgress.lastViewedStep;
            }
        } catch (error) {
            console.error("Error loading help guide progress:", error);
            this.currentStepIndex = 0;
        }
    }
}
// Initialize the help guide when the DOM is fully loaded
document.addEventListener("DOMContentLoaded", ()=>{
    window.auroraHelpGuide = new $0a209b5c3feb59ed$var$HelpGuide();
});


//# sourceMappingURL=app.60bde22c.js.map
